import { useEffect, useRef } from 'react';

import { AppLoader } from '@sternum/web/components';
import { useLastUsedClient, useLogout, useRedirectToDefaultPath } from '@sternum/web/features/auth/hooks';

export function Root() {
  const { lastUsedClient, isLoading: isLastUsedClientLoading, error: lastUsedClientError } = useLastUsedClient();
  const { logout } = useLogout();
  const isLogoutAlreadyTriggered = useRef(false);
  const { redirectToDefaultPath } = useRedirectToDefaultPath();

  const isUnauthorizedError = lastUsedClientError?.data?.code === 'UNAUTHORIZED';

  useEffect(() => {
    if (isUnauthorizedError && !isLastUsedClientLoading && !isLogoutAlreadyTriggered.current) {
      logout();
      isLogoutAlreadyTriggered.current = true;
    }
  }, [isUnauthorizedError, isLastUsedClientLoading, logout]);

  useEffect(() => {
    if (lastUsedClient) {
      redirectToDefaultPath(lastUsedClient).then();
    }
  }, [lastUsedClient, redirectToDefaultPath]);

  if (isLastUsedClientLoading) {
    return <AppLoader />;
  }

  if (lastUsedClientError && !isUnauthorizedError) {
    throw lastUsedClientError;
  }

  if (!lastUsedClient && !isUnauthorizedError) {
    // technically it should never happen, because it means that either
    // user is not invited to any client or no client exists at all
    throw new Error('Current user is not associated with any client');
  }

  return <AppLoader />;
}
